export default {
    'af': $localize`Afghanistan`,
    'ax': $localize`Åland Islands`,
    'al': $localize`Albania`,
    'dz': $localize`Algeria`,
    'as': $localize`American Samoa`,
    'ad': $localize`Andorra`,
    'ao': $localize`Angola`,
    'ai': $localize`Anguilla`,
    'aq': $localize`Antarctica`,
    'ag': $localize`Antigua and Barbuda`,
    'ar': $localize`Argentina`,
    'am': $localize`Armenia`,
    'aw': $localize`Aruba`,
    'au': $localize`Australia`,
    'at': $localize`Austria`,
    'az': $localize`Azerbaijan`,
    'bs': $localize`Bahamas`,
    'bh': $localize`Bahrain`,
    'bd': $localize`Bangladesh`,
    'bb': $localize`Barbados`,
    'by': $localize`Belarus`,
    'be': $localize`Belgium`,
    'bz': $localize`Belize`,
    'bj': $localize`Benin`,
    'bm': $localize`Bermuda`,
    'bt': $localize`Bhutan`,
    'bo': $localize`Bolivia`,
    'bq': $localize`Bonaire, Sint Eustatius and Saba`,
    'ba': $localize`Bosnia and Herzegovina`,
    'bw': $localize`Botswana`,
    'bv': $localize`Bouvet Island`,
    'br': $localize`Brazil`,
    'io': $localize`British Indian Ocean Territory`,
    'bn': $localize`Brunei Darussalam`,
    'bg': $localize`Bulgaria`,
    'bf': $localize`Burkina Faso`,
    'bi': $localize`Burundi`,
    'cv': $localize`Cabo Verde`,
    'kh': $localize`Cambodia`,
    'cm': $localize`Cameroon`,
    'ca': $localize`Canada`,
    'ky': $localize`Cayman Islands`,
    'cf': $localize`Central African Republic`,
    'td': $localize`Chad`,
    'cl': $localize`Chile`,
    'cn': $localize`China`,
    'cx': $localize`Christmas Island`,
    'cc': $localize`Cocos (Keeling) Islands`,
    'co': $localize`Colombia`,
    'km': $localize`Comoros`,
    'cg': $localize`Congo`,
    'cd': $localize`Congo, Democratic Republic of the`,
    'ck': $localize`Cook Islands`,
    'cr': $localize`Costa Rica`,
    'ci': $localize`Côte d'Ivoire`,
    'hr': $localize`Croatia`,
    'cu': $localize`Cuba`,
    'cw': $localize`Curaçao`,
    'cy': $localize`Cyprus`,
    'cz': $localize`Czechia`,
    'dk': $localize`Denmark`,
    'dj': $localize`Djibouti`,
    'dm': $localize`Dominica`,
    'do': $localize`Dominican Republic`,
    'ec': $localize`Ecuador`,
    'eg': $localize`Egypt`,
    'sv': $localize`El Salvador`,
    'gq': $localize`Equatorial Guinea`,
    'er': $localize`Eritrea`,
    'ee': $localize`Estonia`,
    'sz': $localize`Eswatini`,
    'et': $localize`Ethiopia`,
    'fk': $localize`Falkland Islands (Malvinas)`,
    'fo': $localize`Faroe Islands`,
    'fj': $localize`Fiji`,
    'fi': $localize`Finland`,
    'fr': $localize`France`,
    'gf': $localize`French Guiana`,
    'pf': $localize`French Polynesia`,
    'tf': $localize`French Southern Territories`,
    'ga': $localize`Gabon`,
    'gm': $localize`Gambia`,
    'ge': $localize`Georgia`,
    'de': $localize`Germany`,
    'gh': $localize`Ghana`,
    'gi': $localize`Gibraltar`,
    'gr': $localize`Greece`,
    'gl': $localize`Greenland`,
    'gd': $localize`Grenada`,
    'gp': $localize`Guadeloupe`,
    'gu': $localize`Guam`,
    'gt': $localize`Guatemala`,
    'gg': $localize`Guernsey`,
    'gn': $localize`Guinea`,
    'gw': $localize`Guinea-Bissau`,
    'gy': $localize`Guyana`,
    'ht': $localize`Haiti`,
    'hm': $localize`Heard Island and McDonald Islands`,
    'va': $localize`Holy See`,
    'hn': $localize`Honduras`,
    'hk': $localize`Hong Kong`,
    'hu': $localize`Hungary`,
    'is': $localize`Iceland`,
    'in': $localize`India`,
    'id': $localize`Indonesia`,
    'ir': $localize`Iran`,
    'iq': $localize`Iraq`,
    'ie': $localize`Ireland`,
    'im': $localize`Isle of Man`,
    'il': $localize`Israel`,
    'it': $localize`Italy`,
    'jm': $localize`Jamaica`,
    'jp': $localize`Japan`,
    'je': $localize`Jersey`,
    'jo': $localize`Jordan`,
    'kz': $localize`Kazakhstan`,
    'ke': $localize`Kenya`,
    'ki': $localize`Kiribati`,
    'kp': $localize`Korea, Democratic People's Republic of`,
    'kr': $localize`Korea, Republic of`,
    'kw': $localize`Kuwait`,
    'kg': $localize`Kyrgyzstan`,
    'la': $localize`Lao People's Democratic Republic`,
    'lv': $localize`Latvia`,
    'lb': $localize`Lebanon`,
    'ls': $localize`Lesotho`,
    'lr': $localize`Liberia`,
    'ly': $localize`Libya`,
    'li': $localize`Liechtenstein`,
    'lt': $localize`Lithuania`,
    'lu': $localize`Luxembourg`,
    'mo': $localize`Macao`,
    'mg': $localize`Madagascar`,
    'mw': $localize`Malawi`,
    'my': $localize`Malaysia`,
    'mv': $localize`Maldives`,
    'ml': $localize`Mali`,
    'mt': $localize`Malta`,
    'mh': $localize`Marshall Islands`,
    'mq': $localize`Martinique`,
    'mr': $localize`Mauritania`,
    'mu': $localize`Mauritius`,
    'yt': $localize`Mayotte`,
    'mx': $localize`Mexico`,
    'fm': $localize`Micronesia, Federated States of`,
    'md': $localize`Moldova`,
    'mc': $localize`Monaco`,
    'mn': $localize`Mongolia`,
    'me': $localize`Montenegro`,
    'ms': $localize`Montserrat`,
    'ma': $localize`Morocco`,
    'mz': $localize`Mozambique`,
    'mm': $localize`Myanmar`,
    'na': $localize`Namibia`,
    'nr': $localize`Nauru`,
    'np': $localize`Nepal`,
    'nl': $localize`Netherlands`,
    'nc': $localize`New Caledonia`,
    'nz': $localize`New Zealand`,
    'ni': $localize`Nicaragua`,
    'ne': $localize`Niger`,
    'ng': $localize`Nigeria`,
    'nu': $localize`Niue`,
    'nf': $localize`Norfolk Island`,
    'mk': $localize`North Macedonia`,
    'mp': $localize`Northern Mariana Islands`,
    'no': $localize`Norway`,
    'om': $localize`Oman`,
    'pk': $localize`Pakistan`,
    'pw': $localize`Palau`,
    'ps': $localize`Palestine, State of`,
    'pa': $localize`Panama`,
    'pg': $localize`Papua New Guinea`,
    'py': $localize`Paraguay`,
    'pe': $localize`Peru`,
    'ph': $localize`Philippines`,
    'pn': $localize`Pitcairn`,
    'pl': $localize`Poland`,
    'pt': $localize`Portugal`,
    'pr': $localize`Puerto Rico`,
    'qa': $localize`Qatar`,
    're': $localize`Réunion`,
    'ro': $localize`Romania`,
    'ru': $localize`Russian Federation`,
    'rw': $localize`Rwanda`,
    'bl': $localize`Saint Barthélemy`,
    'sh': $localize`Saint Helena, Ascension and Tristan da Cunha`,
    'kn': $localize`Saint Kitts and Nevis`,
    'lc': $localize`Saint Lucia`,
    'mf': $localize`Saint Martin (French part)`,
    'pm': $localize`Saint Pierre and Miquelon`,
    'vc': $localize`Saint Vincent and the Grenadines`,
    'ws': $localize`Samoa`,
    'sm': $localize`San Marino`,
    'st': $localize`Sao Tome and Principe`,
    'sa': $localize`Saudi Arabia`,
    'sn': $localize`Senegal`,
    'rs': $localize`Serbia`,
    'sc': $localize`Seychelles`,
    'sl': $localize`Sierra Leone`,
    'sg': $localize`Singapore`,
    'sx': $localize`Sint Maarten (Dutch part)`,
    'sk': $localize`Slovakia`,
    'si': $localize`Slovenia`,
    'sb': $localize`Solomon Islands`,
    'so': $localize`Somalia`,
    'za': $localize`South Africa`,
    'gs': $localize`South Georgia and the South Sandwich Islands`,
    'ss': $localize`South Sudan`,
    'es': $localize`Spain`,
    'lk': $localize`Sri Lanka`,
    'sd': $localize`Sudan`,
    'sr': $localize`Suriname`,
    'sj': $localize`Svalbard and Jan Mayen`,
    'se': $localize`Sweden`,
    'ch': $localize`Switzerland`,
    'sy': $localize`Syrian Arab Republic`,
    'tw': $localize`Taiwan`,
    'tj': $localize`Tajikistan`,
    'tz': $localize`Tanzania`,
    'th': $localize`Thailand`,
    'tl': $localize`Timor-Leste`,
    'tg': $localize`Togo`,
    'tk': $localize`Tokelau`,
    'to': $localize`Tonga`,
    'tt': $localize`Trinidad and Tobago`,
    'tn': $localize`Tunisia`,
    'tr': $localize`Türkiye`,
    'tm': $localize`Turkmenistan`,
    'tc': $localize`Turks and Caicos Islands`,
    'tv': $localize`Tuvalu`,
    'ug': $localize`Uganda`,
    'ua': $localize`Ukraine`,
    'ae': $localize`United Arab Emirates`,
    'gb': $localize`United Kingdom`,
    'us': $localize`United States of America`,
    'um': $localize`United States Minor Outlying Islands`,
    'uy': $localize`Uruguay`,
    'uz': $localize`Uzbekistan`,
    'vu': $localize`Vanuatu`,
    've': $localize`Venezuela`,
    'vn': $localize`Viet Nam`,
    'vg': $localize`Virgin Islands (British)`,
    'vi': $localize`Virgin Islands (U.S.)`,
    'wf': $localize`Wallis and Futuna`,
    'eh': $localize`Western Sahara`,
    'ye': $localize`Yemen`,
    'zm': $localize`Zambia`,
    'zw': $localize`Zimbabwe`,
}
